
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import ZohoCRMScript from "../../ZohoCRMScript";

const HeroSection = () => {
  return (
    <>
      <ZohoCRMScript />
      <section className="relative py-20 md:py-28 overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="/lovable-uploads/ae067904-295d-4e06-9438-4f820296fe9e.png"
          alt="Cybersecurity team analyzing data"
          className="w-full h-full object-cover object-center"
        />
        {/* Gradient overlay for text readability and blending */}
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 via-slate-800/80 to-slate-900/70"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-slate-900/20 to-slate-900/40"></div>
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8 text-white">
            <div className="space-y-6">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
                Transforming 
                <span className="text-[#8932c8] drop-shadow-lg"> Managed Security Service Providers</span>
              </h1>
              <h2 className="text-2xl md:text-3xl font-semibold text-gray-100 drop-shadow-md">
                Powering the Next-Gen MSSP Model with Spharaka XDR and AuraXP
              </h2>
              <p className="text-lg md:text-xl text-gray-200 leading-relaxed drop-shadow-sm">
                Traditional MSSPs relied heavily on static playbooks and repetitive workflows. In a world driven by dynamic threats and lean security teams, this model is no longer sufficient. The future lies in Agentic AI - not just automating, but acting, learning, and adapting like an intelligent partner.
              </p>
            </div>
            <div className="flex flex-col sm:flex-row gap-4">
              <Dialog>
                <DialogTrigger asChild>
                  <Button 
                    size="cta"
                    className="bg-[#8932c8] hover:bg-[#7a2cb3] text-white shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all duration-300"
                  >
                    Partner with Us
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto">
                  <DialogHeader>
                    <DialogTitle>Partner with Us</DialogTitle>
                  </DialogHeader>
                  <div id='crmWebToEntityForm' className='zcwf_lblTopBottom crmWebToEntityForm' style={{backgroundColor: 'white', color: 'black', maxWidth: '600px', padding: '25px', margin: '0 auto', boxSizing: 'border-box'}}>
                    <form id='webform966770000000627837' action='https://crm.zoho.in/crm/WebToLeadForm' name='WebToLeads966770000000627837' method='POST' onSubmit={() => { return (window as any).checkMandatory966770000000627837(); }} acceptCharset='UTF-8'>
                      <input type='text' style={{display:'none'}} name='xnQsjsdp' value='b4852772ee4fc15953fda75d288e2eaa12d3e5474a40df629a232d4dd98f0931' />
                      <input type='hidden' name='zc_gad' id='zc_gad' value='' />
                      <input type='text' style={{display:'none'}} name='xmIwtLD' value='44138232174f2b196b594ff4cce867d47e8236f2466fac39baca8c716d84ad896ecd0f283ac1d78bbe30c472909e7edc' />
                      <input type='text' style={{display:'none'}} name='actionType' value='TGVhZHM=' />
                      <input type='text' style={{display:'none'}} name='returnURL' value='null' />
                      
                      <div className='text-xl font-semibold mb-6 text-center' style={{color: 'black', fontFamily:'Arial'}}>Partners</div>
                      
                      <div className='mb-4'>
                        <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                          <label htmlFor='First_Name'>First Name <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div>
                          <input 
                            type='text' 
                            id='First_Name' 
                            aria-required='true' 
                            aria-label='First Name' 
                            name='First Name' 
                            maxLength={40}
                            className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                          />
                        </div>
                      </div>
                      
                      <div className='mb-4'>
                        <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                          <label htmlFor='Last_Name'>Last Name <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div>
                          <input 
                            type='text' 
                            id='Last_Name' 
                            aria-required='true' 
                            aria-label='Last Name' 
                            name='Last Name' 
                            maxLength={80}
                            className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                          />
                        </div>
                      </div>
                      
                      <div className='mb-4'>
                        <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                          <label htmlFor='Designation'>Title <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div>
                          <input 
                            type='text' 
                            id='Designation' 
                            aria-required='true' 
                            aria-label='Designation' 
                            name='Designation' 
                            maxLength={100}
                            className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                          />
                        </div>
                      </div>
                      
                      <div className='mb-4'>
                        <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                          <label htmlFor='Email'>Email <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div>
                          <input 
                            type='text' 
                            data-ftype='email' 
                            autoComplete='false' 
                            id='Email' 
                            aria-required='true' 
                            aria-label='Email' 
                            name='Email' 
                            maxLength={100}
                            className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                          />
                        </div>
                      </div>
                      
                      <div className='mb-4'>
                        <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                          <label htmlFor='Phone'>Phone <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div>
                          <input 
                            type='text' 
                            id='Phone' 
                            aria-required='true' 
                            aria-label='Phone' 
                            name='Phone' 
                            maxLength={30}
                            className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                          />
                        </div>
                      </div>
                      
                      <div className='mb-4'>
                        <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                          <label htmlFor='Company'>Company <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div>
                          <input 
                            type='text' 
                            id='Company' 
                            aria-required='true' 
                            aria-label='Company' 
                            name='Company' 
                            maxLength={200}
                            className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                          />
                        </div>
                      </div>
                      
                      <div className='mb-4'>
                        <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                          <label htmlFor='Industry'>Industry <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div>
                          <select 
                            id='Industry' 
                            onChange={(e) => { (window as any).addAriaSelected966770000000627837?.(); }} 
                            aria-required='true' 
                            aria-label='Industry' 
                            name='Industry'
                            className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent bg-white'
                          >
                            <option value='-None-'>-None-</option>
                            <option value='Managed Security Service Providers (MSSPs)'>Managed Security Service Providers (MSSPs)</option>
                            <option value='Systems Integrator (SIs)'>Systems Integrator (SIs)</option>
                            <option value='IT Consulting Firms'>IT Consulting Firms</option>
                            <option value='Value-Added Resellers (VARs)'>Value-Added Resellers (VARs)</option>
                            <option value='Distributors'>Distributors</option>
                          </select>
                        </div>
                      </div>
                      
                      <div className='mb-4'>
                        <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                          <label htmlFor='City'>City <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div>
                          <input 
                            type='text' 
                            id='City' 
                            aria-required='true' 
                            aria-label='City' 
                            name='City' 
                            maxLength={100}
                            className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                          />
                        </div>
                      </div>
                      
                      <div className='mb-4'>
                        <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                          <label htmlFor='Zip_Code'>Zip Code <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div>
                          <input 
                            type='text' 
                            id='Zip_Code' 
                            aria-required='true' 
                            aria-label='Zip Code' 
                            name='Zip Code' 
                            maxLength={30}
                            className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                          />
                        </div>
                      </div>
                      
                      <div className='mb-4'>
                        <div className='mb-2' style={{fontSize:'14px', fontFamily: 'Arial', fontWeight: '500'}}>
                          <label htmlFor='Country'>Country <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div>
                          <input 
                            type='text' 
                            id='Country' 
                            aria-required='true' 
                            aria-label='Country' 
                            name='Country' 
                            maxLength={100}
                            className='w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#8932c8] focus:border-transparent'
                          />
                        </div>
                      </div>
                      
                      <div className='mb-6'>
                        <div className='flex items-start'>
                          <input 
                            autoComplete='off' 
                            id='privacyTool966770000000627837' 
                            type='checkbox' 
                            aria-checked='false' 
                            name='' 
                            aria-errormessage='privacyErr966770000000627837' 
                            aria-label='privacyTool' 
                            onClick={(e) => { (window as any).disableErr966770000000627837?.(); }}
                            className='mt-1 mr-3'
                          />
                          <div className='text-sm text-gray-600'>
                            <a href='http://spharaka.com/privacy-policy' title='http://spharaka.com/privacy-policy' target='_blank' className='text-[#8932c8] hover:underline'>
                              I agree to the Privacy Policy and consent to the processing of my personal data
                            </a>
                          </div>
                        </div>
                        <div id='privacyErr966770000000627837' aria-live='polite' style={{fontSize:'12px', color:'red', paddingLeft: '5px', visibility:'hidden'}}>Please accept this</div>
                      </div>
                      
                      <input type='text' style={{display: 'none'}} name='aG9uZXlwb3Q' value='' />
                      
                      <div className='flex gap-3'>
                        <input 
                          type='submit' 
                          id='formsubmit' 
                          role='button' 
                          className='bg-[#8932c8] hover:bg-[#7a2cb3] text-white px-6 py-2 rounded-md cursor-pointer transition-colors' 
                          value='Submit' 
                          aria-label='Submit' 
                          title='Submit'
                        />
                        <input 
                          type='reset' 
                          role='button' 
                          name='reset' 
                          value='Reset' 
                          aria-label='Reset' 
                          title='Reset'
                          className='border border-gray-300 bg-white text-gray-700 px-6 py-2 rounded-md cursor-pointer hover:bg-gray-50 transition-colors'
                        />
                      </div>
                    </form>
                  </div>
                </DialogContent>
              </Dialog>
              <Dialog>
                <DialogTrigger asChild>
                  <Button 
                    variant="outline" 
                    size="cta"
                    className="border-white/30 bg-white/10 backdrop-blur-sm text-white hover:bg-white hover:text-[#8932c8] shadow-lg hover:shadow-xl transition-all duration-300"
                  >
                    Schedule Demo
                  </Button>
                </DialogTrigger>
                <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto">
                  <DialogHeader>
                    <DialogTitle>Schedule Demo</DialogTitle>
                  </DialogHeader>
                  <div id='crmWebToEntityForm2' className='zcwf_lblLeft crmWebToEntityForm' style={{backgroundColor: 'white', color: 'black', maxWidth: '600px'}}>
                    <form id='webform966770000000572002' action='https://crm.zoho.in/crm/WebToLeadForm' name='WebToLeads966770000000572002' method='POST' onSubmit={() => { return (window as any).checkMandatory966770000000572001(); }} acceptCharset='UTF-8'>
                      <input type='text' style={{display:'none'}} name='xnQsjsdp' value='2eaa648798ce23a7a9a9fdfb797621a05074c8311ce9031824d1b4d79807096f' />
                      <input type='hidden' name='zc_gad' id='zc_gad' value='' />
                      <input type='text' style={{display:'none'}} name='xmIwtLD' value='3b367f412ccfde6c347aca9059e7efedf4cd6eef72f9a51d2beb75a4850be285503386a2c820cee984c68e0e4df8b7e1' />
                      <input type='text' style={{display:'none'}} name='actionType' value='TGVhZHM=' />
                      <input type='text' style={{display:'none'}} name='returnURL' value='null' />
                      
                      <div className='zcwf_row'>
                        <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                          <label htmlFor='First_Name2'>First Name <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div className='zcwf_col_fld'>
                          <input type='text' id='First_Name2' aria-required='true' aria-label='First Name' name='First Name' maxLength={40} />
                        </div>
                      </div>
                      
                      <div className='zcwf_row'>
                        <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                          <label htmlFor='Last_Name2'>Last Name <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div className='zcwf_col_fld'>
                          <input type='text' id='Last_Name2' aria-required='true' aria-label='Last Name' name='Last Name' maxLength={80} />
                        </div>
                      </div>
                      
                      <div className='zcwf_row'>
                        <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                          <label htmlFor='Email2'>Work Email <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div className='zcwf_col_fld'>
                          <input type='text' data-ftype='email' autoComplete='false' id='Email2' aria-required='true' aria-label='Email' name='Email' maxLength={100} />
                        </div>
                      </div>
                      
                      <div className='zcwf_row'>
                        <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                          <label htmlFor='Company2'>Company <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div className='zcwf_col_fld'>
                          <input type='text' id='Company2' aria-required='true' aria-label='Company' name='Company' maxLength={200} />
                        </div>
                      </div>
                      
                      <div className='zcwf_row'>
                        <div className='zcwf_col_lab' style={{fontSize:'12px', fontFamily: 'Arial'}}>
                          <label htmlFor='Description2'>How can we help? <span style={{color:'red'}}>*</span></label>
                        </div>
                        <div className='zcwf_col_fld'>
                          <textarea style={{fontFamily: 'Arial, sans-serif'}} id='Description2' aria-required='true' aria-label='Description' name='Description'></textarea>
                        </div>
                      </div>
                      
                      <div className='zcwf_row'>
                        <div className='zcwf_col_lab'></div>
                        <div className='zcwf_col_fld'>
                          <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '10px'}}>
                            <input type='checkbox' id='privacyConsent2' required style={{marginRight: '8px', marginTop: '2px'}} />
                            <label htmlFor='privacyConsent2' style={{fontSize: '12px', color: '#666', lineHeight: '1.4'}}>
                              I agree to the{" "}
                              <a href='/privacy-policy' target='_blank' style={{color: '#8932c8', textDecoration: 'underline'}}>
                                Privacy Policy
                              </a>{" "}
                              and consent to the processing of my personal data. <span style={{color: 'red'}}>*</span>
                            </label>
                          </div>
                        </div>
                      </div>
                      
                      <input type='text' style={{display: 'none'}} name='aG9uZXlwb3Q' value='' />
                      
                      <div className='zcwf_row'>
                        <div className='zcwf_col_lab'></div>
                        <div className='zcwf_col_fld'>
                          <input type='submit' id='formsubmit' className='formsubmit zcwf_button' value='Submit' style={{backgroundColor: '#8932c8', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer'}} />
                          <input type='reset' className='zcwf_button' name='reset' value='Reset' style={{marginLeft: '10px', padding: '10px 20px', borderRadius: '4px', cursor: 'pointer'}} />
                        </div>
                      </div>
                    </form>
                  </div>
                </DialogContent>
              </Dialog>
            </div>
          </div>
          
          {/* Right side - empty space to showcase the background image */}
          <div className="hidden lg:block">
            {/* This div creates space for the background image to show through */}
          </div>
        </div>
      </div>
    </section>
    </>
  );
};

export default HeroSection;
